module.exports = __webpack_public_path__ + "img/9788989571520.53e0e49d.jpg";